interface ICustomizeModalActionBarProps {
  applyText?: string
  cancelText?: string
  canApply?: () => boolean
  apply: () => void
  cancel: () => void
}

/**
 * Modal Action Bar with following content that is in most "Customize" modals
 * | CANCEL | SAVE & APPLY |
 */
const CustomizeModalActionBar = ({
  applyText = 'SAVE & APPLY',
  cancelText = 'CANCEL',
  canApply,
  apply,
  cancel
}: ICustomizeModalActionBarProps) => {
  return (
    <div className='flex px-6 py-4'>
      <button
        className='ml-auto h-10 w-24 rounded px-6 py-2 font-semibold tracking-[0.02em] text-gray-700'
        onClick={cancel}
      >
        {cancelText}
      </button>
      <button
        className={[
          'ml-2 px-4 py-2',
          'rounded bg-lighthouseBlue',
          'text-white',
          'font-medium',
          'disabled:opacity-50'
        ].join(' ')}
        disabled={typeof canApply === 'function' ? !canApply() : false}
        onClick={apply}
      >
        {applyText}
      </button>
    </div>
  )
}

export default CustomizeModalActionBar
